import View     from 'scripts/poppet/view';
import template from 'templates/radioButtonView.jst.html';

/**
 * defa.views.RadioButton
 * A radio button within a label.
 * @version 1.2.0
 */
const selectors   = {
	input: '[data-input$=-radio]',
};
const RadioButton = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	tagName  : 'div',
	className: '',
	
	ui: {
		input: selectors.input,
	},
	
	events: {
		'change @ui.input': 'onChangeInput',
	},
	
	templateContext: {
		
		radioName: function () {
			let options = this.options || {};
			
			if ( !options.radioName ) {
				options.radioName = 'radio';
			}
			return options.radioName;
		},
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onChangeInput: function () {
		this.trigger( 'selected', this );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default RadioButton;